export default __webpack_public_path__ + "static/media/hulu-logo.1000c859.svg";